/* eslint-disable import/no-anonymous-default-export */
export default {
  "error.message.user_does_not_exist": "User does not exist",
  "error.message.username_not_found": "Email not found",
  "error.message.wrong_password": "Incorrect password",
  "error.message.user_inactive": "Inactive user",
  "error.message.missing_params": "Invalid parameters, please check!",
  "error.message.user_trial_time_expired": "User trial time has expired",
  "error.message.integration_already_exists":
    "An integration between these projects already exists",
  "error.message.integration_project_from_the_same_company":
    "Integration of projects from the same company",
  "error.message.project_already_exists":
    "A project with this name already exists",
  "error.message.projectTemplate_already_exists":
    "A project template with this name already exists",
  "error.message.speciality_already_exists":
    "A specialty with this name already exists",
  "error.message.tenant_trial_time_expired": "Company trial time has expired",
  "error.message.download_not_available": "Download not available",
  "error.message.folder_not_created":
    "An error occurred while creating the folder",
  "error.message.error_on_upload": "Error uploading file",
  "error.message.folder_already_exists": "This folder already exists",
  "error.message.folder_not_found": "Folder not found",
  "error.message.file_not_found": "File not found",
  "error.message.file_not_created": "An error occurred while creating the file",
  "error.message.error": "Some error occurred",
  "error.message.file_already_exists": "This file already exists",
  "error.message.entity_already_saved": "Entity already has access",
  "error.message.invalid_current_password": "Invalid current password",
  "error.status.400": "Invalid request",
  "error.status.401": "Unauthorized",
  "error.status.403": "Forbidden",
  "error.status.404": "Not found",
  "error.status.500": "Internal server error",
  "error.status.502": "Server communication failure",
  "error.status.503": "Service unavailable",
  "error.status.504": "Server communication expired",
};
